export { BaseCopilotTextarea } from "./base-copilot-textarea/base-copilot-textarea";

export { CopilotTextarea } from "./copilot-textarea/copilot-textarea";
export type { CopilotTextareaProps } from "./copilot-textarea/copilot-textarea";
